export type DropEvent = {
  position: {
    x: number;
    y: number;
  };
  item: any;
};

// Deep clone an object
export function clone(obj: any) {
  return JSON.parse(JSON.stringify(obj));
}
